import styled from "styled-components";

export const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;

export const StyledActivityPage = styled.div<{ themeColor: string, campaignColor: string }>`
    height: calc(100dvh + 120px);
    padding: 20px 20px 70px;
    position: relative;
    /* background-color: ${(p) => p.campaignColor}; */
    background-color: #fff;
    position: relative;
    overflow: scroll;
    .layout-img-skeleton {
        .ant-skeleton {
            .ant-skeleton-title {
                height: 250px;
                border-radius: 16px;
                width: 100% !important;
            }
            .ant-skeleton-paragraph {
                li {
                    height: 10px;
                    border-radius: 16px;
                    margin: 0 auto;
                }
            }
        }
        .btn-skeleton {
            .ant-skeleton {
                .ant-skeleton-paragraph {
                    li {
                        height: 52px;
                        border-radius: 16px;
                        width: 100% !important;
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .step-logo {
        display: flex;
        justify-content: center;
        margin: 30px 0;
        .ant-skeleton {
            .ant-skeleton-header {
                text-align: center;
                padding-right: 0;
                span {
                    width: 105px;
                    height: 105px;
                    margin: 0 auto;
                }
            }
        }
        .step {
            display: flex;
            p {
                margin: none;
                background-color: ${(p) => p.themeColor};
                padding: 2px 10px 4px 10px;
                color: ${(p) => p.theme.colors.white};
                border-radius: 100px;
                font-size: 16px;
            }
            div {
                border-top: 3px solid ${(p) => p.themeColor};
                height: 3px;
                width: 20px;
                margin-top: 14px;
            }
        }
        .logo {
            width: 100%;
            text-align: center;
            img {
                width: 100%;
                max-width: 150px;
                height: auto;
            }
        }
    }
    .info {
        text-align: right;
        margin-bottom: 5px;
        img {
            width: 18px;
        }
    }
    .seller-input-section {
        input {
            border: 1px solid ${(p) => p.themeColor};
            border-radius: 15px;
            height: 68px !important;
            color: black;
        }
        .ant-input-suffix {
            z-index: 0;
        }
        .input-btn {
            color: #ffffff;
            background-color: ${(p) => p.themeColor};
            border-radius: 12px;
            height: 43px;
        }
    }
    .ex-receipt {
        font-size: 12px;
        color: ${(p) => p.themeColor};
        text-decoration: underline;
        text-align: center;
        margin-bottom: 16px;
    }
    .select-type {
        .title-select-type {
            font-size: 14px;
            color: #000;
            margin-bottom: 8px;
        }
        .ant-select-single {
            height: 56px;
            margin-bottom: 16px;
        }
        .ant-select {
            width: 100%;
            border-radius: 12px;
            .ant-select-selection-item {
                font-weight: 500;
            }
            .ant-select-selection-selected-value {
                font-size: 13px;
                color: #9b9b9b;
            }
            .ant-select-selection {
                display: flex;
                align-items: center;
            }
        }
    }
    .title-receipt {
        margin-bottom: 16px;
        text-align: center;
        .ant-skeleton {
            .ant-skeleton-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                .ant-skeleton-title {
                    margin-top: 15px;
                    margin-bottom: 12px;
                    height: 10px;
                    border-radius: 16px;
                }
                .ant-skeleton-paragraph {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 15px;
                    li {
                        height: 10px;
                        border-radius: 16px;
                    }
                }
            }
        }
        h1 {
            font-size: 28px;
            font-weight: 500;
            color: #01040d;
            margin: 8px 0 20px;
        }
        p {
            color: #96979c;
            font-size: 14px;
            line-height: 19px;
            font-weight: 400;
            margin-bottom: 20px;
        }
    }
    .view-btn {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: #fff;
        background-color: ${(p) => p.themeColor};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .view-btn-type-2 {
        width: 100%;
        border: 1px solid ${(p) => p.themeColor};
        border-radius: 50px;
        height: 48px;
        color: ${(p) => p.themeColor};
        background-color: ${(p) => p.theme.colors.card};
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            margin-right: 5px;
        }
    }
    .input-title {
        margin-bottom: 5px;
        margin-top: 40px;
        color: ${(p) => p.themeColor};
    }
    .input-receipt {
        height: 58px;
        padding-left: 20px;
        border: 1px solid ${(p) => p.themeColor}70;
        border-radius: 10px;
        outline: none;
    }
    .input-receipt:focus {
        outline: none;
        box-shadow: none;
    }
    .scan-qr {
        text-align: center;
        width: calc(100% + 40px);
        margin-left: -20px;
        margin-top: 20px;
        section {
        }
    }

    .btn-section {
        width: 100%;
        position: relative;
        padding: 15px 0;
        .btn {
            width: 100%;
            height: 48px;
            border-radius: 50px;
            font-size: 16px;
            font-weight: 600;
            box-shadow: none;
            span {
                font-weight: 600;
            }
        }
        .back {
            border: 1px solid ${(p) => p.themeColor};
            color: black;
        }
        .confirm {
            border: 1px solid ${(p) => p.themeColor};
            color: white;
            background-color: ${(p) => p.themeColor};
            span {
                margin-left: 10px;
                img {
                    width: 14px;
                    height: 14px;
                }
            }
        }
    }
    .example-modal {
        position: fixed;
        bottom: 0px;
        width: 480px;
        max-width: 100vw;
        background-color: pink;
        height: 50vh;
        border-radius: 25px 25px 0 0;
    }
`;
